import {
  LayoutContainer,
  PageSection,
  PageSectionContent,
  ThreeDTour,
} from '@greystar/designsystem';
import { getDictionaryEntry, getWindowLocation, useAnalytics } from '@greystar/lib';
import { useEffect } from 'react';
import { PropertyDetailsToursProps } from '../../../component-props';
import { useI18n } from 'next-localization';

const Tours = (props: PropertyDetailsToursProps) => {
  const analytics = useAnalytics();
  const { t } = useI18n();

  useEffect(() => {
    if (!props.tours || props.tours.length === 0) return;

    // Track tour navigation buttons (left/right)
    const handleNavButtonClick = (e: Event) => {
      const target = e.target as HTMLElement;
      const button = target.closest('button.icon-button');
      if (button) {
        const direction = button.getAttribute('data-direction');
        trackTourEvent('tab scroll', direction === 'left' ? 'left' : 'right');
      }
    };

    // Track tab clicks
    const handleTabClick = (e: Event) => {
      const tab = e.target as HTMLElement;
      if (tab.classList.contains('tab')) {
        const tabText = tab.textContent ?? '';
        trackTourEvent('tab click', tabText);
      }
    };

    // Add event listeners
    const tourContainer = document.querySelector('#book-a-tour');
    if (tourContainer) {
      tourContainer.addEventListener('click', handleNavButtonClick);
      tourContainer.addEventListener('click', handleTabClick);
    }

    return () => {
      if (tourContainer) {
        tourContainer.removeEventListener('click', handleNavButtonClick);
        tourContainer.removeEventListener('click', handleTabClick);
      }
    };
  }, [props.tours]);

  const trackTourEvent = (actionType: string, actionValue?: string) => {
    analytics.trackEvent('property_virtual_tour', {
      action_type: actionType,
      state: props.propertyState ?? '',
      property_location: props.propertyLocation ?? '',
      property_id: props.propertyId ?? '',
      property_name: props.propertyName ?? '',
      module_name: 'property details page',
      inpage_location: 'middle',
      click_text: actionValue ?? '',
      click_type: 'internal',
      destination_url: getWindowLocation(),
    });
  };

  if (!props.tours || props.tours.length === 0) return <></>;

  return (
    <PageSection id="book-a-tour" topColour="sky" isTopFlushed="true" isRoundedTop>
      <PageSectionContent hasMaxWidth>
        <LayoutContainer className="pt-[112px] lg:pt-[124px]">
          <ThreeDTour
            tours={props.tours}
            prevLabel={getDictionaryEntry(t('tab-previous-tour'), 'Tab Previous Tour')}
            nextLabel={getDictionaryEntry(t('tab-next-tour'), 'Tab Next Tour')}
          />
        </LayoutContainer>
      </PageSectionContent>
    </PageSection>
  );
};

export default Tours;
